import React from 'react';
import GenericSvgIcon from "./GenericSvgIcon";
import IconType from "@/types/Icon.type";

function IconStarOutline(props: IconType) {
    const {
        width = '20',
        height = '20',
        stroke = '#070c63',
        strokeWidth = '.1',
        fill = '#070c63',
        viewBox = '0 0 20 20',
        title = 'IconStar',
        ...rest
    } = props
    return (
        <GenericSvgIcon
            width={width}
            height={height}
            stroke={stroke}
            strokeWidth={strokeWidth}
            fill={fill}
            viewBox={viewBox}
            title={title}
            {...rest}
            svgIconPath={(
                <path
                    d="m15.1944442 18.9473684c-.194021 0-.3888-.0473684-.5691789-.1424842l-4.5973895-2.4294316c-.1114105-.0583579-.24290524-.0583579-.35279998 0l-4.59814737 2.4294316c-.41191579.2175158-.90227368.1830316-1.28008421-.0898105-.37743158-.2732211-.56311579-.7287158-.48467368-1.188379l.87271579-5.1161684c.02463158-.1466526-.02387369-.2959579-.1296-.3997895l-3.69056842-3.61591575c-.3312-.32437894-.44791579-.80033684-.30429474-1.24143158.144-.44109473.5184-.75675789.97768421-.82383158l5.09267368-.74387368c.14854737-.02197895.27663158-.1152.34294737-.25010526l2.28618948-4.65612632c.20652631-.41911579.62450526-.67945263 1.09136842-.67945263h.00037895c.4664842 0 .8844632.26033684 1.0902316.67945263l2.2858105 4.65536842c.0666947.13528421.1955368.22888421.3444632.25086316l5.0941894.74425263c.4585263.06669474.8325474.38197895.9765474.82269474.1436211.44071579.0272842.91629474-.3039158 1.24029474l-3.6924631 3.61781048c-.1061053.1038316-.1542316.2531369-.1296.3994106l.8730947 5.1165473c.078821.4592842-.1068632.914779-.4842947 1.188379-.2125895.1538526-.461179.2322947-.7112843.2322947zm-5.34315785-3.3737684c.18189475 0 .36454735.0439579.53052635.1322526l4.5977684 2.4294316c.1568842.0826105.3372631.0708632.4816421-.0341053.1443789-.1042105.2125895-.2713263.1822737-.4467789l-.8730948-5.1169263c-.0670736-.3910737.0625264-.7904842.345979-1.0678737l3.6920842-3.61743158c.1258105-.12353684.1682526-.29709474.1140632-.46458947-.0549474-.16711579-.1913685-.28231579-.3656843-.30808421l-5.0938105-.74425263c-.396-.05722106-.7385684-.30656843-.9155368-.66656843l-2.2858106-4.65536842c-.078821-.15991579-.2319157-.25541052-.41039995-.25541052-.17848421 0-.3319579.09587368-.41077895.25616842l-2.28618947 4.65612631c-.17658948.35924211-.51802106.60821053-.91364211.66581053l-5.09305263.74349474c-.17469474.02538947-.31187368.14096842-.36682105.3088421-.05418948.16787369-.01174737.34218948.1144421.46572632l3.69018948 3.61553684c.28345263.2773895.41305263.6768.34597894 1.0682526l-.87271579 5.1161685c-.02993684.1758315.03865264.3425684.18227369.4475368.14475789.1042105.32475789.1163368.4816421.0337263l4.59814737-2.4294316c.16597895-.0882947.34825263-.1322526.53052632-.1322526z"
                />
            )}
        />

    );
}

export default IconStarOutline;
